<!--
    COMPONENTE PARA SELECAO DE ITEM


- QUANDO O CODIGO DO ITEM PESQUISADO FOR IGUAL AO TEXTO DA PESQUISA, CARREGAR DIRETAMENTE NO PEDIDO

-->

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'

export default {
    props: {
        value: {},
        disabled: Boolean,
        addButton: Boolean,
        exibePreco: { type: Boolean, default: true },
        codtabpre: String,
        tipoitem: { type: String , default: 'P' },
    },

    data () {
        return {
            textSearch: '',
            inicio: true,
            noList: false,
            showList: false,
            originalTop: 0,

            isChoosing: true,

            selectedIndex: 0,
            selected: {},

            coditem: null,
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        itemList: function () {
            return this.$store.getters.getItemSalesList
        },

        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },

    },

    filters: {
        format: function (value) {
            return formatValue(value, 4)
        },
    },

    methods: {
        handleNovoItem () {
            this.$emit('novo', this.textSearch)
        },

        handleEsc() {
            if (!this.showList && this.selected.nome) {
                this.isChoosing = false
            } else {
                this.showList = false
                this.textSearch = ''
                this.$refs.pesquisa.focus()
            }
        },

        handleKeyDown () {
            //TECLA PARA BAIXO
            if (this.itemList.length > 0) {
                if (this.selectedIndex > this.itemList.length) {
                    this.selectedIndex = 0
                } else {
                    this.selectedIndex = this.selectedIndex + 1
                }
            }
        },

        handleKeyUp () {
            //TECLA PARA CIMA
            if (this.itemList.length > 0) {
                if (this.selectedIndex < 1) {
                    this.selectedIndex = this.itemList.length - 1
                } else {
                    this.selectedIndex = this.selectedIndex - 1
                }
            }
        },

        handleMore () {
            this.offset = true
            this.loadData()
        },

        handleTrocar() {
            this.isChoosing = true
            this.textSearch = ''
            this.$nextTick(function () {
                this.focus()
            })
        },

        focus () {
            this.$refs.pesquisa.focus()
        },

        closeForm () {
            this.$emit('closeform')
        },

        handleBlur () {
            //this.showList = false
        },

        handleChange() {
            // if (!this.textSearch) {
            //     this.showList = false
            //     return
            // }
        },

        handleSelectItem(index) {
            //AO SELECIONAR UM ITEM
            if (index) {
                this.selectedIndex = index
            }

            if (this.itemList.length > 0) {
                this.selected = this.itemList[this.selectedIndex]
                this.coditem = this.selected.coditem
                this.showList = false
                this.isChoosing = false
                this.textSearch = ''
                this.$emit('input', this.selected.coditem)
                this.$emit('onselect', this.selected)
                this.focusControl()
            }
        },

        search () {
            this.inicio = false

            if (!this.textSearch) {
                this.showList = false
                return
            }

            let tipo = null
            if (this.tipoitem){
              tipo = this.tipoitem
            }

            let text = this.textSearch.toUpperCase()
            this.filter = '{"descricao":{"$or":[{"$like":"%25' + text + '%25"},{"codigo":{"$eq":"' + text + '"}}]} ' + (tipo? ',"$and":[{"tipoitem":{"$eq":"' + tipo + '"}}]' : '') + ' }'

            this.loadData()
        },

        async loadData (coditem) {
            let params = { filter: this.filter, coditem: coditem, codtabpre: this.codtabpre };
            if (this.offset) {
                params.offset = this.nextPage
                this.offset = false
            }
            if (coditem)
              params.filter = ''

            await this.$store.dispatch('loadItemSales', params)
            this.selectedIndex = 0
            if (coditem && this.itemList.length > 0) {
                this.selected = this.itemList[0]
                this.isChoosing = false
            }
        },

        focusControl: function (event) {
            var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
            var next = thisIndex + 1
            var obj = jQuery(SysVars.sFocusControl)
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus()
                    break
                }
            }
        },

    },

    watch: {

        textSearch: function () {
            let vm = this
            if (this.keytimer){
                clearTimeout(this.keytimer);
            }
            this.keytimer = setTimeout(function(){
                vm.search()
            }, 300);
        },

        itemList: function () {
            if (this.inicio) {
                return
            }
            if (!this.itemList.length) {
                this.noList = true
                this.showList = false
            } else {
                this.noList = false
                this.showList = true
            }
        },

        value: function () {
            if (this.value != this.coditem) {
              this.loadData(this.value)
            }
        },

    },

    created () {
        if (this.value) {
            this.loadData(this.value)
        } else
            this.$store.dispatch('clearItemSales')

        this.$nextTick(function () {
            //const rect = this.$refs.pesquisa.getBoundingClientRect();
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    mounted () {
        if (this.value != this.coditem) {
            this.loadData(this.value)
        }
        this.originalTop = this.$el.getBoundingClientRect().top;
    }

}

</script>

<template>
    <div class="row nb-margin-bottom">
        <div style="position: relative; width: 100%; z-index: 10; background-color: white">
            <div v-show="!isChoosing">
                <div class="col-md-12 col-12">
                    <span class="lbl-title-produto"> {{ selected.descricao }} </span>
                    <span class="data-list"> ({{ selected.codigo }})</span>
                </div>
                <div class="col-md-12 col-12">
                    <v-button v-if="!disabled" icon="fa-exchange" label="Trocar Produto" title="Selecionar outro produto" @click="handleTrocar"></v-button>
                </div>
            </div>
            <div v-show="isChoosing">
                <div class="col-md-12 col-12">
                    <div class="input-group input-group-sm">
                        <input ref="pesquisa" class="form-control" id="search" type="text"
                            placeholder="Informe a descrição ou código do produto" v-model="textSearch"
                            @blur="handleBlur()" @change="handleChange()" @keyup.esc="handleEsc()" @keyup.enter="handleSelectItem()"
                            @keyup.down="handleKeyDown()" @keyup.up="handleKeyUp()">
                    </div>
                        <v-label v-if="addButton" label="" title-add-button="Cadastrar Novo Produto" @clickAdd="handleNovoItem"></v-label>
                    <div class="col-md-12 col-12">
                        <ul v-if="noList" class="typeahead typeahead-dropdown col" style="display: block;">
                            <li @click="handleNovoItem">
                                <span class="typeahead-data">Nenhum produto localizado. Clique aqui para incluir um novo.</span>
                            </li>
                        </ul>
                        <ul v-if="showList" class="typeahead typeahead-dropdown col" style="display: block;">
                            <li v-for="(item, index) in itemList" :class="{'active': index == selectedIndex}" :key="index" @click="handleSelectItem(index)">
                                <div class="row">
                                    <div class="col-md-1 col-2">
                                        <img v-if="item.url" :src="item.url" class="mx-auto d-block img-thumbnail" style="width: 45px; height: 45px;" >
                                    </div>
                                    <div class="col-md-6 col-8">
                                        <span class="typeahead-data"><strong>{{ item.descricao }}</strong> - {{ item.codigo }}</span>
                                        <!-- <span v-if="existe(item.coditem)" class="badge badge-yellow-outline">Adicionado</span> -->
                                    </div>
                                    <div class="col-md-3 col-4" v-show="exibePreco">
                                        <span class="typeahead-data">R$ <strong>{{ item.vlrtab | format }}</strong></span>
                                    </div>
                                    <div class="col-md-3 col-3">
                                        <!-- <span class="data-list"><strong>{{ item.qtestoque | format }}</strong></span> -->
                                    </div>
                                </div>
                            </li>
                            <li v-if="nextPage>0" @click="handleMore()">
                                <div>
                                    <span class="typeahead-title"> <small> Exibir Mais </small> </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>





<style scoped>

li {
    line-height: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/input-item.vue